import { render, staticRenderFns } from "./AppMyCalendar.vue?vue&type=template&id=488f2cc4&"
import script from "./AppMyCalendar.vue?vue&type=script&lang=js&"
export * from "./AppMyCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports